import React from "react";
import { FootBar} from "../components/Footer";


export function EmailChecker(){

    
    return(

        <div className="container-fluid">
            
            <div className="row">
                {/* ------------------------------------ */}
                <div className="col-lg-12"> 
                    <div className="row d-flex align-items-center justify-content-center vh-100">
                        <div className="col-lg-6 col-md-8 d-flex flex-column align-items-center">
                            <div className="d-flex align-items-center mb-4">
                                <span className="font-lg color-light ps-4 pe-2 py-1 rounded-start-1 bg-green" > SAMA </span>
                                <span className="font-lg color-light bg-orange py-1 ps-2 pe-4 rounded-end-1 border-start" > DOC </span>
                            </div>
                            <div className="d-flex flex-column align-items-center p-5 border justify-content-center rounded-2 ">
                                <p className="text-secondary text-center font-xl"> Activation de compte utilisateur </p> 
                                <span className="text-secondary text-center lead mb-3"> Votre compte a été créé avec succes. Veuillez consulter votre mail, un message d'activation de compte vous sera envoyé. </span> 
                            </div>
                        </div>
                    </div>
                </div>
                {/* ************************************************* */}
                    <div className="col-lg-12 bg-dark">  <FootBar />  </div>
                {/* ************************************************* */}

            </div>
        </div>

    )
}

